import ContentGroup from './ContentGroup';

export default ContentGroup;
